import AppDetails from './appDetails';

const TAApplicationManage = () => {
    return (
        <AppDetails name='' isSummary />
    );
};

export default TAApplicationManage;
